export default __webpack_public_path__ + "static/media/thsarabunnew_bold-webfont.dd1d9630.eot";